import { ProductKindBadge } from './product-kind-badge'
import type { ColumnDef } from '@tanstack/react-table'
import type { TFunction } from '@kostbar/i18n'
import type { Product } from '@/api/types'
import { Badge } from '@/components/ui/badge'

export const buildProductColumns = (
  tCommon: TFunction<'common'>,
  tProducts: TFunction<'products'>,
): Array<ColumnDef<Product>> => [
  {
    accessorKey: 'sku',
    header: tProducts('fields.sku'),
    cell: ({ row }) => <span className="font-mono">{row.original.sku}</span>,
    meta: { label: tProducts('fields.sku') },
  },
  {
    accessorKey: 'name',
    header: tProducts('fields.productName'),
    meta: { label: tProducts('fields.productName') },
  },
  {
    accessorKey: 'vatCode',
    header: tProducts('fields.vatCode'),
    cell: ({ row }) => <Badge variant="outline">{row.original.vatCode}</Badge>,
    meta: { label: tProducts('fields.vatCode') },
  },
  {
    accessorKey: 'active',
    header: tCommon('status'),
    cell: ({ row }) => (
      <div className="flex items-center gap-2">
        <Badge variant={row.original.active ? 'default' : 'secondary'}>
          {row.original.active ? tCommon('active') : tCommon('inactive')}
        </Badge>
        {/* CHG-2026-09-duplicate-product-merge: a merged duplicate stays in this list — only its
            badge, edit/price/menu actions, and sellability change. */}
        {row.original.mergedIntoSku && (
          <Badge variant="outline">{tProducts('merge.badgeMergedShort')}</Badge>
        )}
        {/* CHG-2026-09-stock-usage-and-price-twins: "Gericht" / "Variante". */}
        <ProductKindBadge product={row.original} />
      </div>
    ),
    meta: { label: tCommon('status') },
  },
]
